import script from "./levelGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./levelGauge.vue?vue&type=script&setup=true&lang=js"

import "./levelGauge.vue?vue&type=style&index=0&id=689397da&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689397da"]])

export default __exports__